import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../../pipes/pipes.module';
import { RouterModule } from '@angular/router';
import { AppRankingsComponent } from './app-rankings/app-rankings.component';
import { FollowUnlockComponent } from './follow-unlock/follow-unlock.component';
import { ChangelogBtnComponent } from './changelog-btn/changelog-btn.component';
import { AppChangelogComponent } from './app-changelog/app-changelog.component';
import { AppChangelogService } from './app-changelog/app-changelog.service';
import { InfoTooltipComponent } from './info-tooltip/info-tooltip.component';
import { DirectivesModule } from 'app/directives/directives.module';
import { RankingsAnonFormComponent } from './rankings-anon-form/rankings-anon-form.component';
import { RiskHeatBarComponent } from './risk-heat-bar/risk-heat-bar';
import { RiskHeatMeterComponent } from './risk-heat-meter/risk-heat-meter';
import { PaginatorComponent } from './paginator/paginator.component';
import { ScrollToTopComponent } from './scroll-to-top/scroll-to-top.component';
import { SwiperModule } from 'swiper/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NotificationSettingsComponent } from './notification-settings/notification-settings.component';
import { SliderToggleComponent } from './slider-toggle/slider-toggle.component';
import { ScoreCardComponent } from './score-card/score-card.component';
import { CountryRankingCardComponent } from './country-ranking-card/country-ranking-card.component';
import { BetaTagComponent } from './beta-tag/beta-tag.component';
import { InfoTooltip2Component } from './info-tooltip2/info-tooltip2.component';
import { NewTagComponent } from './new-tag/new-tag.component';
import { NoDataInfoComponent } from './no-data-info/no-data-info.component';
import { RiskSeverityComponent } from './risk-severity/risk-severity';
import { SvgIconsComponent } from './svg-icons/svg-icons.component';
import { RankingsAnonFormV2Component } from './rankings-anon-form-v2/rankings-anon-form-v2.component';
import { SellerRiskComponent } from './seller-risks.component';
import { RankingsCtaFormAnonymousComponent } from './rankings-cta-form-anonymous/rankings-cta-form-anonymous.component';
import { RankingsCtaFormFreemiumComponent } from './rankings-cta-form-freemium/rankings-cta-form-freemium.component';
import { ShowMoreBtnComponent } from './show-more-btn/show-more-btn.component';
import { ViolationRiskComponent } from './violation-risk/violation-risk';
import { CodeSnippetComponent } from './code-snippet/code-snippet.component';
import { WeekSelectorComponent } from './week-selector/week-selector.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    NgbDropdownModule,
    PipesModule,
    RouterModule,
    DirectivesModule,
    SwiperModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [
    AppRankingsComponent,
    FollowUnlockComponent,
    ChangelogBtnComponent,
    AppChangelogComponent,
    InfoTooltipComponent,
    InfoTooltip2Component,
    RankingsAnonFormComponent,
    RankingsAnonFormV2Component,
    RankingsCtaFormAnonymousComponent,
    RankingsCtaFormFreemiumComponent,
    RiskHeatBarComponent,
    RiskHeatMeterComponent,
    RiskSeverityComponent,
    PaginatorComponent,
    ScrollToTopComponent,
    NotificationSettingsComponent,
    SliderToggleComponent,
    ScoreCardComponent,
    CountryRankingCardComponent,
    BetaTagComponent,
    NewTagComponent,
    NoDataInfoComponent,
    SvgIconsComponent,
    SellerRiskComponent,
    ShowMoreBtnComponent,
    ViolationRiskComponent,
    CodeSnippetComponent,
    WeekSelectorComponent
  ],
  declarations: [
    AppRankingsComponent,
    FollowUnlockComponent,
    ChangelogBtnComponent,
    AppChangelogComponent,
    InfoTooltipComponent,
    InfoTooltip2Component,
    RankingsAnonFormComponent,
    RankingsAnonFormV2Component,
    RankingsCtaFormAnonymousComponent,
    RankingsCtaFormFreemiumComponent,
    RiskHeatBarComponent,
    RiskHeatMeterComponent,
    RiskSeverityComponent,
    PaginatorComponent,
    ScrollToTopComponent,
    NotificationSettingsComponent,
    SliderToggleComponent,
    ScoreCardComponent,
    CountryRankingCardComponent,
    BetaTagComponent,
    NewTagComponent,
    NoDataInfoComponent,
    SvgIconsComponent,
    SellerRiskComponent,
    ShowMoreBtnComponent,
    ViolationRiskComponent,
    CodeSnippetComponent,
    WeekSelectorComponent
  ],
  providers: [AppChangelogService]
})
export class SharedModule {}
